/**
 * Cupom que chega pelo link da loja: `?cupom=CODIGO` (ou `?coupon=CODE`).
 *
 * Location: lib
 * Why: o lojista divulga um link com o cupom da campanha. Quem abre o link
 * ainda vai navegar, entrar na conta e encher o carrinho antes de precisar do
 * cupom, então o código fica guardado na sessão do navegador (some ao fechar a
 * aba) e o carrinho o aplica quando abre.
 *
 * O código vem da URL, ou seja, de fora: só passa o formato de um código de
 * cupom (letras, números, hífen e sublinhado, até 50), e ele nunca é escrito
 * na página como HTML. Quem decide se o cupom vale é a API, na cotação do
 * carrinho, igual a um código digitado à mão.
 */
const CHAVE = 'hystore:cupom-do-link';
const FORMATO = /^[A-Z0-9_-]{1,50}$/;

/** O cupom da busca da URL, em maiúsculas. `null` sem cupom ou fora do formato. */
export function lerCupomDoLink(busca: string): string | null {
  let parametros: URLSearchParams;
  try {
    parametros = new URLSearchParams(busca);
  } catch {
    return null;
  }
  const bruto = parametros.get('cupom') ?? parametros.get('coupon');
  if (!bruto) return null;
  const codigo = bruto.trim().toUpperCase();
  return FORMATO.test(codigo) ? codigo : null;
}

function sessao(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    // Navegador com o armazenamento bloqueado: o link funciona como um link comum.
    return null;
  }
}

/** Guarda o cupom do link, se houver. Chamado uma vez, quando a loja abre. */
export function guardarCupomDoLink(busca: string = window.location.search, armazem: Storage | null = sessao()): string | null {
  const codigo = lerCupomDoLink(busca);
  if (!codigo || !armazem) return codigo;
  try {
    armazem.setItem(CHAVE, codigo);
  } catch {
    /* sem espaço ou bloqueado: segue sem guardar */
  }
  return codigo;
}

/** O cupom guardado, conferido de novo (o armazenamento também é dado de fora). */
export function cupomGuardado(armazem: Storage | null = sessao()): string | null {
  try {
    const codigo = armazem?.getItem(CHAVE) ?? null;
    return codigo && FORMATO.test(codigo) ? codigo : null;
  } catch {
    return null;
  }
}

export function esquecerCupomDoLink(armazem: Storage | null = sessao()): void {
  try {
    armazem?.removeItem(CHAVE);
  } catch {
    /* nada a fazer */
  }
}

/**
 * O carrinho pode aplicar agora o cupom do link? Só uma vez, com o jogador na
 * conta (a cotação é dele), itens no carrinho e nenhum cupom já aplicado: um
 * cupom que o jogador digitou não é trocado pelo do link.
 */
export function podeAplicarCupomDoLink(estado: { autenticado: boolean; itens: number; temCupom: boolean; jaTentou: boolean }): boolean {
  return !estado.jaTentou && estado.autenticado && estado.itens > 0 && !estado.temCupom;
}

